import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function LocationMap() {
  return <section id="location" className="py-16 px-6 bg-rotterdam-black" data-id="element-166">
      <div className="max-w-4xl mx-auto w-full" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="w-full flex flex-col items-center" data-id="element-168">
          <div className="w-full h-[320px] md:h-[450px] rounded-2xl overflow-hidden relative z-10 bg-gray-900" style={{
          boxShadow: '0 0 15px rgba(0, 229, 255, 0.6), 0 0 30px rgba(0, 255, 213, 0.4)',
          border: '1px solid rgba(0, 229, 255, 0.3)'
        }} data-id="element-169">
            <div className="absolute inset-0 flex items-center justify-center bg-gray-900 -z-10" data-id="element-170">
              <div className="w-8 h-8 border-4 border-[#00E5FF] border-t-transparent rounded-full animate-spin" data-id="element-171"></div>
            </div>

            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.334336048123!2d-60.6601449!3d-32.942188!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7ab4376f82705%3A0x6a1c1109153a478b!2sAv.%20Ovidio%20Lagos%201035%2C%20S2000%20Rosario%2C%20Santa%20Fe!5e0!3m2!1ses!2sar!4v1712683000000!5m2!1ses!2sar" className="w-full h-full border-0" style={{
            filter: 'invert(90%) hue-rotate(180deg) contrast(85%)'
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación de Rotterdam Barbería" aria-label="Mapa interactivo de Rotterdam Barbería" data-id="element-172"></iframe>
          </div>

          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4 mt-8 w-full" data-id="element-173">
            <a href="https://www.google.com/maps/dir/?api=1&destination=Av.+Ovidio+Lagos+1035,+Rosario,+Santa+Fe" target="_blank" rel="noopener noreferrer" className="flex-1 min-w-[200px] text-center px-6 py-3 bg-[#00E5FF] text-rotterdam-black font-bold rounded-full hover:bg-[#00FFD5] transition-colors shadow-[0_0_10px_rgba(0,229,255,0.5)]" aria-label="Cómo llegar a la barbería" data-id="element-174">
              Cómo llegar
            </a>
            <a href="https://share.google/F45j5gLCmw4QSstlh" target="_blank" rel="noopener noreferrer" className="flex-1 min-w-[200px] text-center px-6 py-3 border border-[#00E5FF] text-[#00E5FF] font-semibold rounded-full hover:bg-[#00E5FF]/10 transition-colors" aria-label="Ver ubicación en Google Maps" data-id="element-175">
              Ver en Google Maps
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}